// extracted by mini-css-extract-plugin
export default {"itemWrap":"ItemWrap_itemWrap__eWMPj"};